__turbopack_context__.v({
  "container": "articlesTile-module-scss-module__smR3DG__container",
  "dateCell": "articlesTile-module-scss-module__smR3DG__dateCell",
  "emptyMessage": "articlesTile-module-scss-module__smR3DG__emptyMessage",
  "search": "articlesTile-module-scss-module__smR3DG__search",
  "searchInputField": "articlesTile-module-scss-module__smR3DG__searchInputField",
  "tableWrapper": "articlesTile-module-scss-module__smR3DG__tableWrapper",
});
